export const ORDER_SPLIT = {
    ADD_ORDER_SPLIT: "add-order-split",
    FIELDS_MENU: "fields-menu",
    SAVE_ORDER_SPLITS: "save-order-splits",
    SPLIT_ROW: "split-row",
};
